import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  ColumnElement,
  StandardColumnElement,
} from "@easy-email-pro-core/typings";
import React from "react";

import { Column } from "@easy-email-pro-core/components/Elements";
import { cloneDeep, merge } from "lodash";
import { Column as SourceElement } from "../../basic/Column";

const defaultData: ElementDefinition<ColumnElement>["defaultData"] = merge(
  SourceElement.defaultData,
  {
    attributes: {},
    data: {},
  }
);

export const StandardColumn = createBlock<StandardColumnElement>({
  get name() {
    return t("Column");
  },
  defaultData,
  type: StandardType.STANDARD_COLUMN,
  create: (payload) => {
    const defaultData: StandardColumnElement = {
      type: StandardType.STANDARD_COLUMN,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.COLUMN,
  render(params) {
    const { node } = params;
    const cloneAttributes = cloneDeep(node.attributes);
    const {
      "border-enabled": borderEnabled,
      "border-width": borderWidth,
      "border-style": borderStyle,
      "border-color": borderColor,
      ...attributes
    } = cloneAttributes;

    const border = borderEnabled
      ? `${borderWidth || "1px"} ${borderStyle || "solid"} ${
          borderColor || "#AAAAAA"
        }`
      : "";

    return (
      <Column
        idx={params.idx}
        {...attributes}
        border={border}
        data={node.data}
        children={params.children || node.children}
      />
    );
  },
});
